import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "ui/components/dropdown-menu";
import React from "react";
import { Button } from "ui/index";
import Icon from "components/icon";
import { MENU } from "icons";
import HeaderPortal from "components/portal/header-portal";

const DashboardMenu = ({ children }) => {

  return (
    <HeaderPortal className="order-9">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button size="icon" variant="ghost">
            <Icon icon={MENU} className="size-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>{children}</DropdownMenuContent>
      </DropdownMenu>
    </HeaderPortal>
  );
};

export default DashboardMenu;
